/**
 * Task X: customers switch subscription plan mid-term (upgrade / downgrade) — "Change plan" dialog, scheduled change,
 * plan change history, Subscriptions → Settings, report. One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  ["tx.change","Change plan","更改方案"],
  ["tx.title","Change plan","更改订阅方案"],
  ["tx.current","Current plan","当前方案"],
  ["tx.choose","Switch to","更改为"],
  ["tx.none","No other plan to switch to (same billing period and currency, active, sold at this branch).","没有可更改的方案（需相同计费周期与货币、已启用、本分店可售）。"],
  ["tx.dir.upgrade","Upgrade","升级"],
  ["tx.dir.downgrade","Downgrade","降级"],
  ["tx.dir.lateral","Switch","更换"],
  ["tx.pv.title","What happens","更改说明"],
  ["tx.pv.diff","Price difference","差价"],
  ["tx.pv.perPeriod","{amount} per period","每期 {amount}"],
  ["tx.pv.now","Takes effect now","立即生效"],
  ["tx.pv.on","Changes on {date} (next renewal)","于 {date}（下次续费）生效"],
  ["tx.pv.charge","Charged now (prorated for the rest of this period)","现在收取（本期剩余时间按比例计算）"],
  ["tx.pv.credit","Credit on the next invoice (prorated)","按比例抵扣下一张账单"],
  ["tx.pv.noProration","No proration — the new price applies from the next renewal","不按比例计费 — 新价格从下次续费开始"],
  ["tx.pv.noCharge","Nothing to pay now — the new price applies from {date}","现在无需付款 — 新价格从 {date} 开始"],
  ["tx.pv.estimate","Estimate; Stripe calculates the exact amount.","此为估算，实际金额由 Stripe 计算。"],
  ["tx.pv.keep","Credits already granted stay until they expire.","已发放的次数保留至到期。"],
  ["tx.ent.full","The new plan's {what} are added now.","新方案的{what}立即发放。"],
  ["tx.ent.prorata","{what} for the rest of this period are added now.","本期剩余时间对应的{what}立即发放。"],
  ["tx.ent.paid","Added once the prorated amount is paid.","按比例金额付款后发放。"],
  ["tx.ent.next","The new plan's credits and benefits start with the next payment.","新方案的次数与权益从下次付款开始。"],
  ["tx.ent.tier","Membership tier {tier} applies now.","会员等级 {tier} 立即生效。"],
  ["tx.what.credits","credits","次数"],
  ["tx.what.package","package","套餐"],
  ["tx.what.stored_value","stored value","储值"],
  ["tx.what.membership","benefits","权益"],
  ["tx.commit.restart","Minimum commitment restarts: until {date}.","最短承诺期重新计算：至 {date}。"],
  ["tx.commit.keep","Minimum commitment unchanged: until {date}.","最短承诺期不变：至 {date}。"],
  ["tx.confirm.now","Switch now","立即更改"],
  ["tx.confirm.schedule","Schedule change","预约更改"],
  ["tx.done.now","Plan changed to {plan}","已更改为 {plan}"],
  ["tx.done.scheduled","{plan} from {date}","{date} 起改为 {plan}"],
  ["tx.pending","Changes to {plan} on {date}","将于 {date} 更改为 {plan}"],
  ["tx.pending.cancel","Keep current plan","保留当前方案"],
  ["tx.pending.canceled","The scheduled change is cancelled","已取消预约更改"],
  ["tx.history","Plan changes","方案变更记录"],
  ["tx.h.applied","Changed","已更改"],
  ["tx.h.scheduled","Scheduled","已预约"],
  ["tx.h.canceled","Cancelled","已取消"],
  ["tx.h.failed","Failed","失败"],
  ["tx.h.by.customer","by the customer online","客户在线操作"],
  ["tx.h.by.staff","by staff","员工操作"],
  ["tx.h.prorated","prorated {amount}","按比例 {amount}"],
  ["tx.settings","Settings","设置"],
  ["tx.s.title","Switching plan mid-term","期中更改方案"],
  ["tx.s.sub","Customers can upgrade or downgrade their subscription before the period ends. Changes are billed through Stripe on your account.","客户可在本期结束前升级或降级订阅，费用经您的 Stripe 账户收取。"],
  ["tx.s.enabled","Allow switching plan","允许更改方案"],
  ["tx.s.roles","Who can switch a customer's plan","谁可以为客户更改方案"],
  ["tx.s.role.owner","Owner","店主"],
  ["tx.s.role.manager","Manager","经理"],
  ["tx.s.role.cashier","Cashier","收银员"],
  ["tx.s.member","Customers can switch themselves online (member area)","客户可在会员区自行更改"],
  ["tx.s.upgrade","Upgrades take effect","升级生效时间"],
  ["tx.s.downgrade","Downgrades take effect","降级生效时间"],
  ["tx.s.immediate","Immediately","立即"],
  ["tx.s.renewal","At the next renewal","下次续费时"],
  ["tx.s.proration","Prorate immediate changes (charge or credit the difference for the rest of the period)","立即更改按比例计费（本期剩余时间补差价或抵扣）"],
  ["tx.s.credits","On an immediate upgrade, the new plan's credits","立即升级时，新方案的次数"],
  ["tx.s.credits.full","are added in full","全额发放"],
  ["tx.s.credits.prorata","are added pro-rata for the rest of the period","按本期剩余时间比例发放"],
  ["tx.s.credits.none","start with the next payment","从下次付款开始"],
  ["tx.s.commit","Minimum commitment restarts on a plan change","更改方案后最短承诺期重新计算"],
  ["tx.s.restrict","Only allow these switches","仅允许以下更改"],
  ["tx.s.restrictHint","Off: any active plan with the same billing period and currency. Downgrades and same-price switches are never charged now.","关闭时：任何相同计费周期与货币的启用方案。降级与同价更换不会立即收费。"],
  ["tx.s.from","From {plan} to","从 {plan} 改为"],
  ["tx.s.saved","Plan change settings saved","方案更改设置已保存"],
  ["tx.r.changes","Plan changes","方案变更"],
  ["tx.r.upgrades","Upgrades","升级"],
  ["tx.r.downgrades","Downgrades","降级"],
  ["tx.r.movement","MRR movement","月经常性收入变动"],
  ["tx.r.movementHint","+{up} expansion · {down} contraction","扩张 +{up} · 收缩 {down}"],
  ["tx.r.scheduled","Scheduled plan changes","已预约的方案更改"],
  ["tx.r.recent","Recent plan changes","近期方案变更"],
  ["w7.ev.subscription_changed","Subscription plan changed","订阅方案已更改"],
  ["w7.ev.subscription_change_scheduled","Subscription plan change scheduled","订阅方案更改已预约"],
] as const;

export type TxKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TxKey, string>;

export const taskX = { en: col(1), zh: col(2), ms: col(1) };
